
<!-- 
<app-test-svg></app-test-svg> -->
<div [@trigger]=currentState>
    <div class=gradient>
        <app-header-image></app-header-image>
        <app-bradshaw></app-bradshaw>
    </div>
    <app-try-lesson ></app-try-lesson>
    <app-try-again></app-try-again>
    <app-faq></app-faq>  


    
</div>


